// Sélection des inputs de type "file"
document.querySelectorAll('input[type="file"]').forEach(input => {
    input.addEventListener('change', function () {
        const val = this.value;
        const formattedVal = val.replace('C:\\fakepath\\', '');
        const sibling = this.parentNode.querySelector('.o-form-control__file');
        if (sibling) {
            sibling.innerHTML = formattedVal;
        }
    });
});
